import { styled } from "@linaria/react"

import { Horizontal } from "@/components/Flex.ts"
import { MatterLogo } from "@/routes/auth/Logo.tsx"

export const MatterLogoAndName = () => {
  return (
    <a href="https://www.jetbrains.com/lp/matter/" target="_blank" rel="noopener noreferrer">
      <Horizontal gap="10px" alignItems="center">
        <MatterLogo />
        <MatterName>Matter</MatterName>
      </Horizontal>
    </a>
  )
}

const MatterName = styled.span`
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -1.01px;
  color: var(--text-color);
`
